export const FETCH_AWARD = {
  START: 'START_FETCH_AWARD',
  COMPLETE: 'COMPLETE_FETCH_AWARD',
  FAIL: 'FAIL_FETCH_AWARD',
  CLEANUP: 'CLEANUP_FETCH_AWARD',
}

export const UPDATE_AWARD_SIMPLE_DETAILS = {
  START: 'START_UPDATE_AWARD_SIMPLE_DETAILS',
  COMPLETE: 'COMPLETE_UPDATE_AWARD_SIMPLE_DETAILS',
  FAIL: 'FAIL_UPDATE_AWARD_SIMPLE_DETAILS',
}
